<template>
	<div class="layout">
		<div class="layout-navigator">
			<div class="layout-logo">
				<img src="../../assets/logo.png">
				河北省司法鉴定案<br>
				件受理管理系统
			</div>
			<div class="layout-navigation custom-scroll-bar">
				<div class="layout-item" v-for="(item,index) in navigate" :key="index" v-if="item.meta.show">
					<router-link :to="{path:item.path,query:{menutype:item.type}}"
						:class="index==navigateIndex?'layout-item-select':''">
						<img :src="item.meta.icon">
						{{item.meta.name}}
					</router-link>
				</div>
			</div>
			<div class="layout-time">
				<el-link href="http://hbsfjd.intcont.bjzjtp.com/login.html" target="_blank">河北司法鉴定文书无纸化系统</el-link>
				<br>
				{{timeStr}}
				<br>
				技术支持：{{supportEmail}}
			</div>
		</div>
		<div class="layout-view">
			<div class="layout-title">
				<div class="layout-name">
					<img src="../../assets/icon_top_menu@2x.png">
					{{routerObj.name}}
				</div>
				<div class="layout-search">
					<el-input placeholder="搜索编号、委托人" v-model="keyword" clearable>
						<el-button slot="append" icon="el-icon-search" @click="doSearch(keyword,false)"></el-button>
					</el-input>
				</div>
				<div class="layout-avatar">
					<div class="layout-avatar-in">
						<img :src="user.avatar" v-if="user.avatar!=''">
						<img src="../../assets/avatar-boy.png" v-if="user.avatar==''&&user.gender==3">
						<img src="../../assets/avatar-girl.png" v-if="user.avatar==''&&user.gender==4">
					</div>
					{{user.name}}
				</div>
				<div class="layout-safety">
					<div class="layout-icon-back">
						<img src="../../assets/icon_top_id@2x.png">
					</div>
					<div class="layout-identity" v-if="realStatus">
						<div class="layout-identity-title">
							身份核验已通过
							<i class="el-icon-success"></i>
						</div>
						<div class="layout-identity-image">
							<img :src="user.front">
							<img :src="user.back">
						</div>
						<div class="layout-identity-name">
							姓名：{{user.name}}
						</div>
						<div class="layout-identity-code">
							身份证号码：{{user.identity}}
						</div>
					</div>
				</div>
				<div class="layout-logout" @click="changePass()">
					<div class="layout-icon-back">
						<i class="el-icon-lock"></i>
					</div>
				</div>
				<div class="layout-logout">
					<div class="layout-icon-back" @click="doLogout">
						<img src="../../assets/icon_top_exit@2x.png">
					</div>
				</div>
			</div>
			<div class="layout-page">
				<router-view ref="queryData" @freshList="freshList"></router-view>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		mapMutations
	} from 'vuex'
	export default {
		name: 'layout',
		data() {
			return {
				navigate: [],
				timeStr: '',
				routerObj: {
					name: ''
				},
				user: {
					avatar: '',
					name: '',
					front: '',
					back: '',
					identity: ''
				},
				keyword: '',
				navigateIndex: 0,
				realStatus: false,
				category: '',
				supportEmail: 'support@sfjdzx.org.cn'
			};
		},
		computed: {
			getUserInfo() {
				return this.$store.state.userInfo
			}
		},
		watch: {
			getUserInfo(userInfo) {
				this.user = userInfo
				this.realStatus = userInfo.realStatus
			},
			keyword: function(a, b) {
				this.doSearch(a, false)
			},
			$route(to, from) {
				let index, name, id;
				let caseType = to.meta.caseType
				if (caseType != 0) {
					for (let i = 0; i < this.navigate.length; i++) {
						if (this.navigate[i].meta.caseType == caseType) {
							index = i, name = to.meta.name, id = to.meta.caseType
							break;
						}
					}
					this.keyword = ''
					this.navigateIndex = index
					this.routerObj.name = name
					this.category = id
					this.$pub.setStorage('i_navigateIndex', index)
					this.doSearch(this.keyword, true)
				}
			}
		},
		methods: {
			...mapMutations(['logout']),
			freshList() {
				this.doSearch(this.keyword, true)
			},
			showRealHint() {
				this.navigateIndex = -1
				this.$message({
					message: '请先完成身份核验，才能使用完整功能！',
					type: 'warning',
					duration: 1500,
					onClose: () => {
						this.$router.push({
							path: '/real'
						})
					}
				});
			},
			queryRealStatus() {
				// 查询实名认证状态
				this.realStatus = this.$store.state.realStatus
				if (!this.realStatus) {
					this.showRealHint()
				}
			},
			doLogout() {
				this.$confirm('请问是否确认退出登录？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.resetHeader()
					this.$message({
						type: 'success',
						message: '退出登录成功',
						duration: 1500,
						onClose: () => {
							this.logout()
						}
					});
				}).catch(() => {});
			},
			doSearch(keyword, flag) {
				if (this.$router.history.current.path != '/real') {
					setTimeout(() => {
						this.$refs.queryData.fetchDataWithKeyword(this.category, keyword, flag)
					}, 300)
				}
			},
			getDate() {
				let date = new Date()
				let year = date.getFullYear()
				let month = date.getMonth() + 1
				let day = date.getDate()
				let hour = date.getHours()
				let minute = date.getMinutes()
				this.timeStr = year + '年' + month + '月' + day + '日 ' + hour + ':' + minute
			},
			changePass() {
				this.$router.push({
					path: '/forget'
				})
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.navigate = this.$store.state.leftNav
			this.routerObj.name = this.navigate[0]['meta']['name']
			let menutype = this.$route.query.menutype
			if (!menutype) {
				window.history.pushState(null, null, window.location.href + '?menutype=' + this.navigate[0]['type'])
				this.$refs.queryData.menutype = this.navigate[0]['type']
			}
			// 查询保存
			if (this.$pub.getStorage('i_navigateIndex')) {
				this.navigateIndex = this.$pub.getStorage('i_navigateIndex')
			}
			this.category = this.navigate[this.navigateIndex].meta.caseType
			this.user = this.$store.state.userInfo
			this.queryRealStatus()
			if (this.$store.state.realStatus) {
				this.doSearch(this.keyword, true)
			}
			this.getDate()
			let interval = setInterval(() => {
				this.getDate()
			}, 60000)
			document.onkeydown = (event) => {
				let e = event || window.event || arguments.callee.caller.arguments[0]
				if (e && e.keyCode == 13) {
					this.doSearch(this.keyword, false)
				}
			}
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	.layout {
		width: 100vw;
		height: 100vh;
		display: flex;
		justify-content: space-between;

		.layout-navigator {
			width: 220px;
			height: 100%;
			background: #2c3451;
			position: relative;

			.layout-logo {
				width: 100%;
				height: 100px;
				display: flex;
				align-items: center;
				color: #E3E3E3;
				padding: 0px 15px;
				box-sizing: border-box;

				img {
					width: 40px;
					height: 40px;
					margin-right: @vue-spacing-row-sm;
				}
			}

			.layout-navigation {
				width: 100%;
				height: calc(100% - 200px);
				overflow: auto;
				padding: 0px 15px;
				box-sizing: border-box;

				.layout-item {
					width: 100%;
					height: 50px;
					margin-bottom: 12px;

					a {
						width: 100%;
						height: 100%;
						display: flex;
						align-items: center;
						color: #F0F0F0;
						font-size: 14px;
						border-radius: 12px;
						padding-left: 10px;
						box-sizing: border-box;

						img {
							width: 26px;
							margin-right: 12px;
						}
					}

					.layout-item-select {
						background: #313f6e;
					}
				}
			}

			.layout-time {
				width: 100%;
				height: 100px;
				line-height: 30px;
				text-align: center;
				color: #FFFFFF;
				font-size: @vue-font-size-min;

				.el-link {
					color: @vue-text-color-inverse;
					font-size: @vue-font-size-sm - 2;
				}
			}
		}

		.layout-view {
			width: calc(100vw - 220px);
			height: 100%;

			.layout-title {
				width: 100%;
				height: 70px;
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding: 0px 15px;
				box-sizing: border-box;
				border-bottom: 1px solid #D3D3D3;

				.layout-name {
					width: 30%;
					height: 100%;
					display: flex;
					align-items: center;
					font-size: 16px;
					color: #464F6D;
					font-weight: bold;

					img {
						width: 22px;
						height: 22px;
						margin-right: 4px;
					}
				}

				.layout-search {
					width: 45%;
					height: 100%;
					display: flex;
					justify-content: flex-end;
					align-items: center;

					.el-input {
						width: 400px;
					}
				}

				.layout-avatar {
					width: 15%;
					height: 100%;
					display: flex;
					align-items: center;
					font-size: 14px;
					color: #464F6D;
					font-weight: bold;
					padding-left: 20px;
					box-sizing: border-box;

					.layout-avatar-in {
						width: 55px;
						height: 55px;
						border-radius: 50%;
						overflow: hidden;
						margin-right: 12px;

						img {
							width: 100%;
							height: 100%;
						}
					}
				}

				.layout-safety,
				.layout-logout {
					width: 5%;
					height: 30px;
					display: flex;
					justify-content: center;
					cursor: pointer;

					.layout-icon-back {
						width: 30px;
						height: 30px;
						background: #F0F0F0;
						border-radius: 50%;
						display: flex;
						justify-content: center;
						align-items: center;

						img {
							width: 20px;
						}
					}
				}

				.layout-safety {
					position: relative;
					border-left: 1px solid #D3D3D3;
					box-sizing: border-box;
					justify-content: flex-end;

					.layout-identity {
						width: 315px;
						height: 210px;
						position: absolute;
						top: 46px;
						right: 0px;
						z-index: 999;
						background: @vue-bg-color;
						border: 1px solid @vue-border-color;
						padding: 0px 12.5px;
						box-sizing: border-box;
						display: none;

						.layout-identity-title {
							width: 100%;
							height: 50px;
							display: flex;
							align-items: center;
							font-size: 14px;

							i {
								color: #13CE66;
								margin-left: 8px;
								font-size: 18px;
							}
						}

						.layout-identity-image {
							width: 100%;
							height: 81px;
							display: flex;
							justify-content: space-between;

							img {
								width: 130px;
								height: 100%;
							}
						}

						.layout-identity-name,
						.layout-identity-code {
							width: 100%;
							height: 40px;
							font-size: 12px;
							color: @vue-text-color-grey;
						}

						.layout-identity-name {
							display: flex;
							align-items: center;
						}
					}
				}

				.layout-safety:hover {
					.layout-icon-back {
						background: #B3D8FF;
					}

					.layout-identity {
						display: block;
					}
				}

				.layout-logout:hover {
					.layout-icon-back {
						background: #B3D8FF;
					}
				}
			}

			.layout-page {
				width: 100%;
				height: calc(100vh - 70px);
				overflow: auto;
			}
		}
	}
</style>
